import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.99992 2V5L17.9999 5V2H19.9999V5H21.9999V7H19.9999V15H21.9999V17H19.9999V21H17.9999V17H15.9999V15H17.9999V7H7.99992V11H5.99992V7H1.99992V5H5.99992V2H7.99992ZM14.5807 10.4185L10.2051 23.5453L7.19684 17.8023L1.45386 14.7941L14.5807 10.4185Z"}}]};

const MapNavigationFilled = Vue.extend<IconProps>({
  name: 'MapNavigationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-navigation-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapNavigationFilled;
